const comments = [
  {
    name: '影迷小明',
    text: '爱丫爱丫影院的片源更新速度真的快，画质也超棒，已经成为我的主力观影平台了。',
    time: '3 天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20portrait%20avatar%20with%20warm%20coral%20tones%2C%20minimalist%20flat%20design%20style%2C%20soft%20rounded%20shapes%2C%20clean%20and%20modern&width=100&height=100&seq=avatar-01&orientation=squarish',
  },
  {
    name: '电影控阿杰',
    text: '动作片资源太全了，好多之前找不到的老片子这里都有，画质修复得也很不错。',
    time: '5 天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20portrait%20avatar%20with%20warm%20amber%20tones%2C%20minimalist%20flat%20design%20style%2C%20soft%20rounded%20shapes%2C%20clean%20and%20modern&width=100&height=100&seq=avatar-02&orientation=squarish',
  },
  {
    name: '小周的观影日记',
    text: '周末宅家一口气看了三部经典电影，播放流畅不卡顿，体验满分。推荐给所有热爱电影的朋友。',
    time: '1 周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20portrait%20avatar%20with%20warm%20terracotta%20tones%2C%20minimalist%20flat%20design%20style%2C%20soft%20rounded%20shapes%2C%20clean%20and%20modern&width=100&height=100&seq=avatar-03&orientation=squarish',
  },
  {
    name: '电影爱好者老陈',
    text: '作为老影迷，这里的经典电影修复版让我重新找回了当年在影院看片的感动，必须五星好评。',
    time: '2 周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20geometric%20portrait%20avatar%20with%20warm%20bronze%20tones%2C%20minimalist%20flat%20design%20style%2C%20soft%20rounded%20shapes%2C%20clean%20and%20modern&width=100&height=100&seq=avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            听听电影爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((c) => (
            <article
              key={c.name}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                    {c.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{c.time}</span>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </span>
                ))}
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {c.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}